import $ from 'jquery';
import Barba from 'barba.js';

import Features from './features';

export default class Single {
    constructor(){
        this.slider();
        if ($('.swiper-container').length > 0) {
            this.swiper();
        }
        this.pagination();

        const feature = new Features();
        feature.colors('section aside.push .content article', 0, 0);

        this.randomColor();

        $(document).on('click', '.single #section-images', function () {
            if ($(window).width() < 768) {
                $(this).toggleClass('full');
            }
        });
    }

    slider() {
        $('#section-images img').eq(0).css('transform', 'translateY(0%)');
        for (var cpt = 1; cpt < $('#section-images img').length;) {
            $('#section-images img').eq(cpt).css('transform', 'translateY(calc(100% + 50px)))');
            cpt++;
        }
    }

    swiper() {
        $('.swiper-container').each(function (i, el) {
            new Swiper(el, {
                mode: 'horizontal',
                slidesPerView: 3,
                freeMode: true,
                freeModeFluid: true,
                momentumRatio: 0.45,
                calculateHeight: true
            });
        });
    }
    pagination() {
        var cpt = 1;
        $('.single section article.col-1, .page-template-gabarit-job article.col-1').each(function () {
            $('section #pagination').append('<div><span>0' + cpt + '</span></div>');
            cpt++;
        });
    }
    randomColor() {
        var getColor;
        var colorArray = [
            '#7ed6cc',
            '#fd8282',
            '#ffd861',
            '#63b0f0'
        ];
        const feature = new Features();

        if (Barba.HistoryManager.history.length < 2) {
            switch (colorArray[parseInt(feature.getRandom(0, 4))]) {
                case colorArray[0]:
                    getColor = 'vert';
                    break;

                case colorArray[1]:
                    getColor = 'rouge';
                    break;

                case colorArray[2]:
                    getColor = 'jaune';
                    break;

                case colorArray[3]:
                    getColor = 'bleu';
                    break;

                default:
                    getColor = '';
                    break;
            }
            $('body').addClass(getColor);
        }
    }
}